import { _axios } from "../../../Utils/Axios/axios";

export const submitAdEndService = async (
  userToken: string,
  adId: string | number
) => {
  return _axios.post(
    `/end_advertise/${String(adId)}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
